import { ArrowUpRight } from "lucide-react";
import { PERSONAS } from "@/data/site";
import { Eyebrow, FadeIn } from "@/components/blocks";

export default function Audience() {
  return (
    <section data-testid="audience-section" className="bg-bone px-6 py-28 text-ink sm:px-10 sm:py-36 lg:px-16">
      <div className="mx-auto max-w-[1440px]">
        <FadeIn>
          <Eyebrow tone="ink">Who It’s For</Eyebrow>
        </FadeIn>
        <FadeIn delay={0.1}>
          <h2 className="mt-8 max-w-4xl font-display text-4xl font-black uppercase leading-[0.95] tracking-tight sm:text-6xl lg:text-7xl">
            For people who expect more <span className="text-ink/40">from their body.</span>
          </h2>
        </FadeIn>

        <div className="mt-16">
          {PERSONAS.map((p, i) => (
            <FadeIn key={p.name} delay={i * 0.04}>
              <div
                data-testid={`persona-${p.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="group grid cursor-default items-center gap-2 border-t border-ink/15 px-4 py-7 transition-colors duration-300 last:border-b hover:bg-ink sm:grid-cols-[80px_1fr_1fr_40px] sm:gap-8 sm:py-8"
              >
                <p className="font-mono text-xs uppercase tracking-[0.3em] text-ink/40 transition-colors group-hover:text-lime">
                  {String(i + 1).padStart(2, "0")}
                </p>
                <h3 className="font-display text-2xl font-black uppercase tracking-tight transition-colors group-hover:text-bone sm:text-3xl">
                  {p.name}
                </h3>
                <p className="text-sm text-smoke transition-colors group-hover:text-ash sm:text-base">{p.note}</p>
                <ArrowUpRight className="hidden h-6 w-6 text-ink/25 transition-all duration-300 group-hover:translate-x-1 group-hover:-translate-y-1 group-hover:text-lime sm:block" />
              </div>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
}
